import Spinner from '@/atoms/loader/Spinner';
import MosaicItem from '@/molecules/MosaicItem/MosaicItem';
import Tile from '@/molecules/Tile';
import useCardVariants from 'components/template/Cards/details/hooks/useCardVariants';
import { useTranslation } from 'next-i18next';

const VariantsTile = ({ reference }: { reference: string }) => {
  const { t } = useTranslation();
  const { variants } = useCardVariants(reference);

  return (
    <Tile title={t('variants')} withDivider>
      {variants && variants.length > 0 ? (
        <div className="grid-12 gap-y-6 items-end">
          {variants.map((card) => (
            <MosaicItem
              key={card.id}
              cardRef={card.reference}
              className="col-span-6 lg:col-span-4"
              imagePath={card.imagePath || '/card-back.jpg'}
              inMyCollection={card.inMyCollection}
              // @ts-expect-error variant cards' stats are not typed ?
              inMySale={card.inMySale}
              linkProps={{ href: `/cards/${card.reference}`, label: 'see-details' }}
              name={card.name || ''}
              rarity={card.rarity?.reference}
            />
          ))}
        </div>
      ) : (
        <Spinner />
      )}
    </Tile>
  );
};

export default VariantsTile;
